import { useMemo } from 'react'
import { useAppSelector } from '@/redux/rootReducer'
import { selectAttendeeInfo, selectMeetingInfo, selectRpiMeetingId, selectTwilioStunServer } from '@/redux/reducers/consultation.reducer'
import { selectCustomDevices } from '@/redux/reducers/custom-device.reducer'
import { getEnv } from '@/utils/helpers'
import { selectPeerId } from '@/redux/reducers/room.reducer'

export function useConsultationRTCConfig({ streamer }: { streamer?: string } = {}) {
  const customDevices = useAppSelector(selectCustomDevices)
  const medicalVideoAttendeeInfo = useAppSelector((state) => selectAttendeeInfo(state, 'medicalVideo'))
  const medicalVideoMeetingInfo = useAppSelector((state) => selectMeetingInfo(state, 'medicalVideo'))
  const stethoscopeAttendeeInfo = useAppSelector((state) => selectAttendeeInfo(state, 'stethoscope'))
  const stethoscopeMeetingInfo = useAppSelector((state) => selectMeetingInfo(state, 'stethoscope'))
  const peerId = useAppSelector(selectPeerId)
  const rpiMeetingId = useAppSelector(selectRpiMeetingId)
  const twilioStunServer = useAppSelector(selectTwilioStunServer)

  const rtcConfig = useMemo(
    () =>
      !twilioStunServer
        ? undefined
        : {
            iceServers: twilioStunServer.iceServers,
          },
    [twilioStunServer]
  )

  const rpiConfig = useMemo(
    () =>
      !rpiMeetingId
        ? undefined
        : {
            meetingID: rpiMeetingId,
            serverUrl: getEnv('VITE_RPI_GATEWAY')!,
          },
    [rpiMeetingId]
  )

  const peerjsConfig = useMemo(
    () =>
      peerId && streamer
        ? {
            config: rtcConfig,
            peerId,
            streamer,
          }
        : undefined,
    [peerId, rtcConfig, streamer]
  )

  return {
    customDevices,
    medicalVideoAttendeeInfo,
    medicalVideoMeetingInfo,
    peerId,
    peerjsConfig,
    rpiConfig,
    rpiMeetingId,
    rtcConfig,
    stethoscopeAttendeeInfo,
    stethoscopeMeetingInfo,
  }
}
